<template>
    <!--My profile content-->
    <div class="myskov-profile">
        <msg-block v-if="customerLoading && !customer">
            <p><b v-text="translations.loading"></b></p>
        </msg-block>
        <div class="profile-block" v-if="customer">
            <div class="profile-block__intro">
                <div class="profile-picture">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.04 26.96">
                        <path d="M26,27H1a1,1,0,0,1-.59-1.81,21.19,21.19,0,0,1,7.94-3.54,1,1,0,0,0,.83-1c0-.54,0-1.12,0-1.73a5.16,5.16,0,0,0-.79-2.21,6.94,6.94,0,0,1-1-2.78,7.83,7.83,0,0,1-.87-3.18,1.65,1.65,0,0,1,.4-1.22c-.07-.34-.13-.7-.19-1.06l0-.17c-.06-.37-.12-.71-.18-1C6,4.11,7,2.18,9.78.92L9.9.85A6.56,6.56,0,0,1,12.55.06a7.45,7.45,0,0,1,3.26.32l.37.09c.44.11.79.21,1,.28,2.72,1,3.9,3.26,3.33,6.45-.07.35-.12.7-.18,1s-.14.83-.22,1.23a1.65,1.65,0,0,1,.4,1.22,7.7,7.7,0,0,1-.88,3.18,7,7,0,0,1-1,2.86,5.13,5.13,0,0,0-.76,2.14c0,.6,0,1.18,0,1.73a1,1,0,0,0,.83,1,21.21,21.21,0,0,1,7.93,3.54A1,1,0,0,1,26,27ZM4.65,25H22.39a16,16,0,0,0-4.05-1.38,3,3,0,0,1-2.48-3.07c0-.52,0-1.07,0-1.64a6.67,6.67,0,0,1,1-3.06,5.89,5.89,0,0,0,.77-2,2.08,2.08,0,0,1,.19-.77,6,6,0,0,0,.68-2.31v0a2,2,0,0,1-.36-1.56c.07-.38.14-.78.2-1.19s.12-.71.19-1.07c.53-2.94-.9-3.8-2-4.2-.17-.06-.47-.14-.83-.23l-.38-.09a5.53,5.53,0,0,0-2.54-.27,4.59,4.59,0,0,0-2,.59l-.17.09c-2,.9-2.53,1.93-2.14,4.11l.18,1,0,.21q.09.53.18,1a2,2,0,0,1-.36,1.56v0A5.86,5.86,0,0,0,9.21,13a2,2,0,0,1,.19.77,5.3,5.3,0,0,0,.75,2,6.94,6.94,0,0,1,1,3.15c0,.57,0,1.12,0,1.64A3,3,0,0,1,8.7,23.58,16,16,0,0,0,4.65,25Zm3.7-14.09h0Zm10.34,0Z"/>
                    </svg>
                </div>
                <div class="profile-block__intro__text">
                    <h2 v-text="translations.title.replace(/{name}/, customer.firstName)"></h2>
                    <p><span v-text="translations.member_since"></span> {{ memberSinceDate }}</p>
                    <p><span v-text="translations.last_ip"></span> {{ customer.lastLoginIp }}</p>
                </div>
                <button class="btn btn--negative" v-text="translations.close_account" v-if="!showCloseAccountInfoBox" @click="showCloseAccountInfoBox = true"></button>
            </div>
            <msg-block v-if="showCloseAccountInfoBox" type="warning">
                <p ><b v-text="translations.close_account_check"></b></p>
                <div class="input-fields">
                    <div class="input-fields__content">
                        <input-field :value="closeAccountTxt" @input="(inp) => closeAccountTxt = inp" @enter="closeAccount" class="booking-field booking-field--firstname"></input-field>
                    </div>
                    <msg-block type="error" v-if="closeAccountError">
                        <p><b v-text="closeAccountError"></b></p>
                    </msg-block>
                </div>
            </msg-block>
        </div>
        <div class="profile-block" v-if="customer">
            <div class="profile-block__heading">
                <h3 v-text="translations.update_profile_title"></h3>
            </div>
            <div class="profile-block__text">
                <p v-text="translations.update_profile_txt"></p>
            </div>
            <div class="input-fields">
                <div class="input-fields__content">
                        <input-field :name="translations.input_firstname" :value="customer.firstName" @input="(inp) => $set(customer, 'firstName', inp)" class="booking-field booking-field--firstname"></input-field>
                        <input-field :name="translations.input_lastname" :value="customer.lastName" @input="(inp) => $set(customer, 'lastName', inp)" class="booking-field booking-field--lastname"></input-field>
                </div>
                    <msg-block type="error" v-if="errors.firstName || errors.lastName">
                        <p v-if="errors.firstName"><b v-text="errors.firstName[0]"></b></p>
                        <p v-if="errors.lastName"><b v-text="errors.lastName[0]"></b></p>
                    </msg-block>
            </div>
            <div class="input-fields">
                <div class="input-fields__header">
                        <h3 v-text="translations.address_hader"></h3>
                </div>
                <div class="input-fields__content">
                        <input-field :name="translations.input_address" :value="customer.address" @input="(inp) => $set(customer, 'address', inp)" class="booking-field booking-field--address"></input-field>
                </div>
                    <msg-block type="error" v-if="errors.address">
                        <p v-if="errors.address"><b v-text="errors.address[0]"></b></p>
                    </msg-block>
            </div>
            <div class="input-fields">
                <div class="input-fields__content">
                        <input-field :name="translations.input_postal" input-type="tel" :value="customer.zipCode" mask="9999" @input="(inp) => $set(customer, 'zipCode', inp.substr(0,4))" class="booking-field booking-field--zipcode"></input-field>
                        <input-field :name="translations.input_town" :value="customer.city" @input="(inp) => $set(customer, 'city', inp)" class="booking-field booking-field--city"></input-field>
                </div>
                    <msg-block type="error" v-if="errors.zipCode || errors.city">
                        <p v-if="errors.zipCode"><b v-text="errors.zipCode[0]"></b></p>
                        <p v-if="errors.city"><b v-text="errors.city[0]"></b></p>
                    </msg-block>
            </div>
            <div class="input-fields">
                <div class="input-fields__content">
                        <selector v-model="customer.countryCode" :options="countries" icon-type="drop-down" class="booking-field booking-field--country"></selector>
                </div>
                <msg-block type="error" v-if="errors.countryCode">
                    <p v-if="errors.countryCode"><b v-text="errors.countryCode[0]"></b></p>
                </msg-block>
            </div>
            <div class="input-fields">
                <div class="input-fields__header">
                    <h3 v-text="translations.contact_header"></h3>
                </div>
                <div class="input-fields__content">
                        <input-field :name="translations.input_email" input-type="email" :value="customer.email" @input="(inp) => $set(customer, 'email', inp)" class="booking-field booking-field--mail"></input-field>
                </div>
                <msg-block type="error" v-if="errors.email">
                    <p v-if="errors.email"><b v-text="errors.email[0]"></b></p>
                </msg-block>
            </div>
            <div class="input-fields">
                <div class="input-fields__content">
                    <span class="booking-field booking-field--countrycode-text">+</span>
                    <input-field :name="translations.input_countrycode" mask="99" input-type="tel" :value="phone_contrycode" @input="(inp) => this.phone_contrycode = inp.substr(0,2)" class="booking-field booking-field--countrycode"></input-field>
                    <input-field :name="translations.input_phone" input-type="tel" :value="phone_number" @input="(inp) => this.phone_number = inp" class="booking-field booking-field--phone"></input-field>
                </div>
                <msg-block type="error" v-if="errors.phone">
                    <p v-if="errors.phone"><b v-text="errors.phone[0]"></b></p>
                </msg-block>
            </div>
            <button class="btn btn--info" v-text="translations.update_profile_btn" @click="updateProfile" :disabled="customerLoading" :class="{'item-loading': customerLoading}"></button>
            <msg-block type="error" v-if="customerError">
                <p><b v-text="customerError"></b></p>
            </msg-block>
            <msg-block v-if="customerSuccess" type="success">
                <p><b v-text="translations.customer_success"></b></p>
            </msg-block>
        </div>
        <div class="profile-block" v-if="customer">
            <div class="profile-block__heading">
                <h3 v-text="translations.password_header"></h3>
            </div>
            <div class="input-fields">
                <div class="input-fields__header">
                    <h3 v-text="translations.input_old_password"></h3>
                </div>
                <div class="input-fields__content">
                    <input-field :name="translations.input_old_password" input-type="password" :value="oldpassword" @input="(val) => oldpassword = val" class="booking-field booking-field--mail"></input-field>
                </div>
                <msg-block type="error" v-if="pw_errors.oldpassword">
                    <p v-for="error in pw_errors.oldpassword"><b v-text="error"></b></p>
                </msg-block>
            </div>
            <div class="input-fields">
                <div class="input-fields__header">
                    <h3 v-text="translations.input_password"></h3>
                </div>
                <div class="input-fields__content">
                    <input-field :name="translations.input_password" input-type="password" :value="password" @input="(val) => password = val" class="booking-field booking-field--mail"></input-field>
                </div>
                <msg-block type="error" v-if="pw_errors.password">
                    <p v-for="error in pw_errors.password"><b v-text="error"></b></p>
                </msg-block>
            </div>
            <div class="input-fields">
                <div class="input-fields__header">
                    <h3 v-text="translations.input_password_confirm"></h3>
                </div>
                <div class="input-fields__content">
                    <input-field :name="translations.input_password_confirm" input-type="password" :value="confirm_password" @input="(val) => confirm_password = val" class="booking-field booking-field--mail"></input-field>
                </div>
                <msg-block type="error" v-if="pw_errors.confirm_password">
                    <p v-for="error in pw_errors.confirm_password"><b v-text="error"></b></p>
                </msg-block>
                <button class="btn btn--info" v-text="translations.save_new_password_btn" @click="changePw" :disabled="pwLoading" :class="{'item-loading': pwLoading}"></button>
                <msg-block type="error" v-if="pwError">
                    <p><b v-text="pwError"></b></p>
                </msg-block>
                <msg-block v-if="pwSucess" type="success">
                    <p><b v-text="translations.pw_success_msg"></b></p>
                </msg-block>
            </div>
        </div>
    </div>
</template>

<script>
import InputField from '../input-field.vue';
import Selector from '../selector.vue';
import MsgBlock from '../msg-block.vue';
import Validate from 'validate.js';
import Moment from 'moment'
import _ from 'underscore';
import SkovApi from '../../skovapi.js';

export default {
    data() {
        return {
            phone_number: '',
            phone_contrycode: '45',
            translations: APP_CONFIG.TRANSLATION.MYSKOV_PROFILE,
            customer: null,
            showCustomerErrrors: false,
            showPwErrors: false,
            customerLoading: false,
            pwLoading: false,
            pwSucess: false,
            customerSuccess: false,
            password: '',
            confirm_password: '',
            oldpassword: '',
            errors: { },
            pw_errors: { },
            pwError: null,
            customerError: null,
            closeAccountError: null,
            showCloseAccountInfoBox: false,
            closeAccountTxt: '',
            closeAccountLoading: false
        }
    },
    mounted() {
        this.$store.dispatch('getCountries');
        this.getUser();
    },
    watch: {
        phoneNumber() {
            if(this.customer) {
                this.customer.phone = this.phoneNumber;
            }
        },
        validProfile() {
            if(this.showCustomerErrrors) {
                this.errors = this.validProfile;
            } else {
                this.errors = { };
            }
        },
        validPassword() {
            if(this.showPwErrors) {
                this.pw_errors = this.validPassword;
            } else {
                this.errors = { };
            }
        },
        showPwErrors() {
            if(this.showPwErrors) {
                this.pw_errors = this.validPassword;
            } else {
                this.errors = { };
            }
        },
        showCustomerErrrors() {
            if(this.showCustomerErrrors) {
                this.errors = this.validProfile;
            } else {
                this.errors = { };
            }
        },
        'customer.zipCode'() {
            if(this.customer.zipCode && this.customer.zipCode.length === 4) {
                SkovApi.getTownByZip(this.customer.zipCode).then((town) => {
                    if(town) {
                        this.$set(this.customer, 'city', town);
                    }
                });
            }
        },
    },
    methods: {
        getUser(updateUser) {
            this.customerLoading = true;
            this.$store.dispatch('getUser').then((user) => {
                if(user.phone) {
                    this.phone_contrycode = user.phone.substr(1,2);
                    this.phone_number = user.phone.substr(3);
                }

                this.customer = user;
                this.customerLoading = false;
                if(updateUser) {
                    this.customerSuccess = true;
                }
            }).catch((error) => {
                this.customerLoading = false;
            });
        },
        closeAccount() {
            this.closeAccountError = null;

            if(!this.$store.state.loggedInUser.email || this.closeAccountTxt.toLowerCase() !== this.$store.state.loggedInUser.email.toLowerCase()) {
                this.closeAccountError = this.translations.ERRORS.close_account_wrong;
                return;
            }

            if(this.closeAccountLoading)
                return;

            SkovApi.deleteUser().then((res) => {
                this.$store.commit('loggedInUser', { });
                this.$store.commit('authToken', null);
                window.location = '/#/?msg=user_deleted';
            }).catch((error) => {
                console.error(error);
                this.closeAccountError = this.translations.ERRORS.close_account_error;
            })
        },
        updateProfile() {
            this.customerSuccess = false;
            this.customerError = null;

            if(!_.isEmpty(this.validProfile)) {
                this.showCustomerErrrors = true;
                return;
            }

            if(this.customerLoading)
                return;

            this.showCustomerErrrors = false;
            this.customerLoading = true;
            SkovApi.updateUser(this.customer).then((res) => {
                this.getUser(true);
            }).catch((error) => {
                this.customerLoading = false;
                if(error.response && error.response.data && error.response.data.message === 'Email is already in use') {
                    this.customerError = this.translations.ERRORS.email_taken;
                } else {
                    console.error(error);
                    this.customerError = this.translations.ERRORS.customer_update;
                }
            });
        },
        changePw() {
            this.pwSucess = false;
            this.pwError = null;

            if(!_.isEmpty(this.validPassword)) {
                this.showPwErrors = true;
                return;
            }

            if(this.pwLoading)
                return;

            this.showPwErrors = false;
            this.pwLoading = true;
            SkovApi.updateUser({password: this.password, identityChallenge: this.oldpassword}).then((res) => {
                this.pwLoading = false;
                this.pwSucess = true;
                this.password = '';
                this.oldpassword = '';
                this.confirm_password = '';
            }).catch((error) => {
                console.error(error);
                this.pwError = this.translations.ERRORS.pw_update;
                this.pwLoading = false;
                this.password = '';
                this.oldpassword = '';
                this.confirm_password = ''; 
            });
        }
    },
    computed: {
        phoneNumber() {
            return '+' + this.phone_contrycode.toString() + this.phone_number.toString();
        },
        memberSinceDate() {
            let m = Moment(this.customer.memberSince, 'YYYY-MM-DD HH:mm:ss')
            return m.format('DD. MMMM YYYY') + ' kl. ' + m.format('HH:mm');
        },
        countries() {
            return [{
                text: this.translations.input_country,
                value: " "
            }].concat(this.$store.state.countries.map((country) => {
                return {
                    text: country.name,
                    value: country.code
                }
            }));
        },
        validProfile() {
            let errors = { };
            errors = Object.assign(errors, Validate(this.customer, {
                firstName: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.firstName  
                    }
                },
                lastName: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.lastName
                    }
                },
                address: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.address
                    }
                },
                zipCode: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.zipCode
                    },
                    numericality: {
                        message: this.translations.ERRORS.zipCode 
                    },
                    length: {
                        is: 4,
                        message: this.translations.ERRORS.zipCode_tooshort
                    }
                },
                city: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.city
                    }
                },
                countryCode: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.countryCode
                    }
                },
                email: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.email
                    },
                    email: {
                        message: this.translations.ERRORS.email_not_valid
                    }
                },
                phone: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.phone
                    },
                    format: {
                        pattern: /^\+[0-9]{9,10}$/,
                        flags: "m",
                        message: this.translations.ERRORS.phone_format
                    }
                }
            }, {
                fullMessages: false
            }));

            return errors;
        },
        validPassword() {
            let errors = Object.assign({ }, Validate({password: this.password, oldpassword: this.oldpassword}, {
                oldpassword: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.oldpassword
                    }
                },
                password: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.password
                    },
                    length: {
                        minimum:5,
                        maximum: 128,
                        message: this.translations.ERRORS.password_not_valid
                    }
                }
            }, {
                fullMessages: false
            }))

            if(this.password != this.confirm_password) {
                errors.confirm_password = [this.translations.ERRORS.password_confirm];
            }

            return errors;
        }
    },
    components: {
        InputField,
        Selector,
        MsgBlock
    }
}
</script>
